function initBasket() {
	try {
		document.addEventListener('click', e => {
			const closeBtn = e.target.closest('.item-Card-buy__remove-product-js')

			if (!closeBtn) return

			const productCard = closeBtn.closest('.Card-buy__wrapper-item-products')

			if (!productCard) return

			if (closeBtn) {
				productCard.classList.add('hidden')
			}
		})

		document.addEventListener('click', e => {
			const closeBtnProduct = e.target.closest('.item-Card-buy__remove-item-js')

			if (!closeBtnProduct) return

			const productCardItem = closeBtnProduct.closest('.item-Card-buy__item-detailed')

			if (!productCardItem) return

			if (closeBtnProduct) {
				let counter = productCardItem.querySelector('.Counter__input')
				counter.value = 0
			}
		})

		if (document.querySelector('.basket-page .Card-buy')) {
			let parEl = document.querySelector('.basket-page .Card-buy')
			let checkboxes = parEl.querySelectorAll('.Checkbox--default input:not(.checkbox--select-all)')
			let selectAll = parEl.querySelector('.checkbox--select-all')
			checkboxes.forEach(inp => {
				inp.addEventListener('change', () => {
					if (checkboxes.length !== document.querySelectorAll('[checked]:not(.checkbox--select-all)').length) {
						selectAll.checked = false
						selectAll.removeAttribute('checked')
					} else {
						selectAll.checked = true
						selectAll.setAttribute('checked', '')
					}
				})
			})
			selectAll.onclick = () => {
				selectAll.checked ? checkboxes.forEach(inp => { inp.checked = true; inp.setAttribute('checked', '') }) : checkboxes.forEach(inp => { inp.checked = false; inp.removeAttribute('checked') })
			}
		}
	} catch { }
}
